/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FlexItem, Container, TruncatedText } from '@waca/ca-ui-toolkit';
import * as glassContext from 'ba-glass-context';
import './FilterListItem.scss';

/*
 * FilterList implementation (leverages List.js)
 */
export default class FilterListItem extends Component<any, any> {
	static propTypes = {
		caption: PropTypes.string,
		subcaption: PropTypes.string,
		showPath: PropTypes.bool,
		matchesCondition: PropTypes.bool,
	};

	static defaultProps = {
		showPath: false,
		matchesCondition: false,
	};

	render() {
		const { showPath, caption, subcaption, matchesCondition } = this.props;
		const textDir = glassContext.getTextDirPref();

		return showPath ? (
			<FlexItem gutter={[2, 0, 0, 0]} grow>
				<TruncatedText value={caption} bolder={matchesCondition} textDir={textDir} />
				<Container className="bi-filter-list-item-path">
					<TruncatedText value={subcaption} bolder={matchesCondition} textDir={textDir} />
				</Container>
			</FlexItem>
		) : (
			<FlexItem grow>
				<TruncatedText value={caption} bolder={matchesCondition} textDir={textDir} />
			</FlexItem>
		);
	}
}
